import _toConsumableArray from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\toConsumableArray.js";
import _asyncToGenerator from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\asyncToGenerator.js";
import _defineProperty from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\defineProperty.js";
import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/uploader/style";
import _Uploader from "vant/es/uploader";
import "vant/es/goods-action-button/style";
import _GoodsActionButton from "vant/es/goods-action-button";
import "vant/es/goods-action/style";
import _GoodsAction from "vant/es/goods-action";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/tag/style";
import _Tag from "vant/es/tag";
import "vant/es/card/style";
import _Card from "vant/es/card";
import "vant/es/button/style";
import _Button from "vant/es/button";

var _components;

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as imageConversion from 'image-conversion';
import { upload } from '@/api/upload';
import { report as reportApi } from '@/api/user';
export default {
  name: 'Home',
  components: (_components = {}, _defineProperty(_components, _Button.name, _Button), _defineProperty(_components, _Card.name, _Card), _defineProperty(_components, _Tag.name, _Tag), _defineProperty(_components, _Toast.name, _Toast), _defineProperty(_components, _GoodsAction.name, _GoodsAction), _defineProperty(_components, _GoodsActionButton.name, _GoodsActionButton), _defineProperty(_components, _Uploader.name, _Uploader), _defineProperty(_components, _Field.name, _Field), _defineProperty(_components, _ImagePreview.Component.name, _ImagePreview.Component), _components),
  data: function data() {
    return {
      showLoading: false,
      fileList: [],
      uploadData: [],
      recordImg: [],
      report_image: this.$route.query.report_image || []
    };
  },
  computed: {
    UploadLimt: function UploadLimt() {
      var RECORD_COUNT = this.recordImg.length;
      var REMAIN_COUNT = 10 - RECORD_COUNT;
      return REMAIN_COUNT;
    }
  },
  created: function created() {
    this.recordImg = this.$route.query.report_image.map(function (item, index) {
      return {
        index: index,
        url: item
      };
    });
  },
  methods: {
    // 展示图片
    showImg: function showImg(arr, index) {
      _ImagePreview({
        images: arr,
        closeable: true,
        startPosition: index
      });
    },
    // 文件读取前的回调函数
    beforeRead: function beforeRead(file) {
      var _this = this;

      this.showLoading = true;

      if (file instanceof Array) {
        file.forEach(function (v) {
          _this.checkFile(v);
        });
      } else {
        this.checkFile(file);
      }

      return true;
    },
    // 读取文件回调前检查+压缩
    checkFile: function checkFile(file) {
      console.log(file, '检查');
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';

      if (!isJpgOrPng) {
        _Toast.fail('上传图片只能是JPG或PNG格式!');

        return false;
      }
    },
    // 成功读取文件回调
    afterRead: function afterRead(file, detail) {
      var _this2 = this;

      console.log(file, '成功读取文件回调');

      if (file instanceof Array) {
        file.map(function (v) {
          _this2.uploadImg(v, detail);
        });
      } else {
        this.uploadImg(file, detail);
      }
    },
    // 将图片上传至服务器
    uploadImg: function uploadImg(file, detail) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isLt2M, formData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(file, detail, '上传'); // 大于2M压缩

                isLt2M = file.file.size / (1024 * 1024).toFixed(2) > 2;

                if (!isLt2M) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return imageConversion.compressAccurately(file.file, 1536).then(function (res) {
                  file.file = res;
                });

              case 5:
                formData = new FormData();
                formData.append('image', file.file);
                _context.next = 9;
                return upload(formData).then(function (res) {
                  if (res.error.code === 0) {
                    _this3.showLoading = false;

                    _this3.uploadData.push({
                      url: res.data.url,
                      index: detail.index
                    }); // 用detail.index其实不对，多选的时候，index是同一个，这样删除的时候就对应不上，不过用下标删除也行

                  }
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 文件删除前的回调函数
    beforeDelete: function beforeDelete(file, detail) {
      console.log(file, detail, '删除'); // detail.index每个文件的下标

      this.uploadData.splice(detail.index, 1);
      return true;
    },
    // 确认上传
    confirm: function confirm() {
      var _this4 = this;

      if (this.uploadData.length === 0) {
        _Toast.fail('请至少上传一张图片');

        return false;
      }

      this.recordImg.forEach(function (item) {
        if (item.url.indexOf('https') !== -1) {
          var arr = item.url.split('/');
          var tempArr = arr.slice(arr.length - 2, arr.length);
          var string = tempArr.join('/');
          item.url = string;
        }
      });
      var record = this.recordImg.map(function (item) {
        return item.url;
      });
      var upload = this.uploadData.map(function (item) {
        return item.url;
      });
      var report = [].concat(_toConsumableArray(record), _toConsumableArray(upload)); // const report = []

      console.log(this.recordImg, record, this.uploadData, upload, report, '确认上传');
      reportApi({
        report: report
      }).then(function (res) {
        if (res.error.code === 0) {
          _Toast('上传成功');

          _this4.$router.push({
            name: 'personal'
          });
        }
      });
    },
    // 返回
    onClickLeft: function onClickLeft() {
      this.$router.go(-1);
    }
  }
};